export default "__VITE_ASSET__k3ti1s1r__"